import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPTrueUpRecordsResponse } from './types';

export function useTrueUpRecords(companyId: number | null) {
  const baseUrl = `tp-true-up?companyId=${companyId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPTrueUpRecordsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
